module.exports = __webpack_public_path__ + "static/takealook_hover-eb5e8fee2c6d8724c0350b5f834acc2a.png";